import React from 'react';
import {
	AnyComponent,
	OverlayModalComponentProps,
	PiletApi,
} from '@sharefiledev/sharefile-appshell';
import { storagePiletModelKeys } from '@sharefiledev/storage-plugin-pilet-sdk';

const LazyLoadedImportFromStorageProviderModal = React.lazy(
	() => import('./ImportFromStorageProviderModal')
);
export function addModals(piletApi: PiletApi) {
	piletApi.registerModal(
		storagePiletModelKeys.ImportFromStorageProvider,
		LazyLoadedImportFromStorageProviderModal as AnyComponent<
			OverlayModalComponentProps<'urn:sfmodal:storage-plugin-pilet:import-from-storage-provider'>
		>,
		{ modalProps: { footer: false } }
	);
}
